import React from 'react';
import DataGrid2 from '../..';

export const ContextMenuCellComponent = props => {
	const bcDataGrid: DataGrid2 = props.data.column.retrieveDataGridInstance();

	const onClick = e => {
		bcDataGrid.__onShowContextMenu(e, props.data);
	};

	return (
		<div style={containerStyles}>
			<span
				style={textStyles}
				title={props.data.text}
			>
				{props.data.text}
			</span>
			<i
				onClick={onClick}
				style={buttonStyles}
				className="dx-icon dx-icon-overflow"
			/>
		</div>
	);
};

const containerStyles: React.CSSProperties = {
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center'
};

const textStyles: React.CSSProperties = {
	display: 'inline-block',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	textAlign: 'left'
};

const buttonStyles: React.CSSProperties = {
	cursor: 'pointer',
	padding: '3px'
};
